import { useEffect } from "react";

interface UseKeyboardShortcutsProps {
  togglePlay?: () => void; // Made optional as it might not always be relevant
  skipBackward?: (() => void) | undefined;
  skipForward?: (() => void) | undefined;
  stopAgent?: () => void; // Added stopAgent callback
}

const useKeyboardShortcuts = ({
  togglePlay,
  skipBackward,
  skipForward,
  stopAgent,
}: UseKeyboardShortcutsProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Prevent shortcuts if typing in an input/textarea
      if (
        e.target &&
        e.target instanceof HTMLElement &&
        e.target.matches("input, textarea, [contenteditable]")
      ) {
        return;
      }

      if (e.code === "Space" && togglePlay) {
        e.preventDefault();
        togglePlay();
      } else if (e.code === "ArrowLeft" && skipBackward) {
        e.preventDefault();
        skipBackward();
      } else if (e.code === "ArrowRight" && skipForward) {
        e.preventDefault();
        skipForward();
      } else if (e.key === "Escape" && stopAgent) {
        // Changed from e.code to e.key for 'Escape'
        e.preventDefault();
        stopAgent();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [togglePlay, skipBackward, skipForward, stopAgent]); // Added stopAgent to dependency array
};

export default useKeyboardShortcuts;
